import React, { useMemo } from "react";
import VerticalPoints from "../../../Common/VerticalPoints/VerticalPoints";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  closeCenteredModal,
  openCenteredModal,
} from "../../../../REDUX/actions/centeredModal";
import ActionForm from "./ActionForm";
import ConfirmModal from "../../../Common/Modal/ConfirmModal";
import {
  convertReminderToAction,
  deleteProspectAction,
} from "../../../../REDUX/actions/prospects";

const ActionOptions = ({ isReminder, actionData }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const options = useMemo(() => {
    const editOption = {
      text: isReminder ? t("Edit Reminder") : t("Edit Action"),
      callback: () =>
        dispatch(
          openCenteredModal(
            <ActionForm
              status={actionData?.status}
              action={isReminder ? "REMINDER" : "ACTION"}
              data={actionData}
              handleClose={() => dispatch(closeCenteredModal())}
            />
          )
        ),
    };

    const deleteOption = {
      text: isReminder ? t("Delete Reminder") : t("Delete Action"),
      callback: () =>
        dispatch(
          openCenteredModal(
            <ConfirmModal
              id={actionData?.id}
              label={t(`${isReminder ? "Reminder" : "Action"}`)}
              onConfirm={() =>
                dispatch(deleteProspectAction(actionData?.id, t))
              }
            />
          )
        ),
    };

    return isReminder
      ? [
          editOption,
          {
            text: t("Convert to Action"),
            callback: () => {
              dispatch(
                openCenteredModal(
                  <ConfirmModal
                    text="Are you sure you want to convert this reminder to an action"
                    confirmText={t("Validate")}
                    onConfirm={() =>
                      dispatch(convertReminderToAction(actionData?.id))
                    }
                  />
                )
              );
            },
          },
          deleteOption,
        ]
      : [editOption, deleteOption];
  }, [isReminder, t, dispatch, actionData]);

  return (
    <div className="position-absolute top-0 end-0 me-2 mt-3">
      <VerticalPoints showLeft options={options} />
    </div>
  );
};

export default ActionOptions;
